import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';

import { ErpSyncDataQualityPage } from '@pages/erp-sync-data-quality';

export const Route = createFileRoute('/$locale/_authenticated/erp-sync/data-quality')({
  validateSearch: z.object({
    contract: z.string().optional(),
  }),
  component: ErpSyncDataQualityRoute,
});

function ErpSyncDataQualityRoute() {
  const { locale } = Route.useParams();
  const search = Route.useSearch();
  const navigate = useNavigate();

  return (
    <ErpSyncDataQualityPage
      initialContractKey={search.contract}
      onOpenMapping={(contractKey) => {
        void navigate({
          to: '/$locale/erp-sync/mapping',
          params: { locale },
          search: { contract: contractKey },
        });
      }}
      onOpenReadiness={(contractKey) => {
        void navigate({
          to: '/$locale/erp-sync/readiness',
          params: { locale },
          search: { contract: contractKey },
        });
      }}
      onOpenEvidence={(batchId) => {
        void navigate({
          to: '/$locale/erp-sync/evidence',
          params: { locale },
          search: { focus: `run:${batchId}` },
        });
      }}
    />
  );
}
